<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 22 22"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path clip-rule="evenodd" d="M22 3C22 4.65685 20.6569 6 19 6C17.8443 6 16.8413 5.34654 16.3402 4.38897L5.70712 9.70552C5.89486 10.0974 6 10.5364 6 11C6 11.4636 5.89486 11.9026 5.70712 12.2945L16.3402 17.611C16.8413 16.6535 17.8443 16 19 16C20.6569 16 22 17.3431 22 19C22 20.6569 20.6569 22 19 22C17.3431 22 16 20.6569 16 19C16 18.8554 16.0102 18.7131 16.03 18.574L5.12245 13.1202C4.57947 13.6637 3.829 14 3 14C1.34315 14 0 12.6569 0 11C0 9.34315 1.34315 8 3 8C3.829 8 4.57947 8.33625 5.12245 8.87981L16.03 3.42603C16.0102 3.28687 16 3.14463 16 3C16 1.34315 17.3431 0 19 0C20.6569 0 22 1.34315 22 3Z" :fill="fill" fill-rule="evenodd"/>
  </svg>

</template>

<script>
export default {
  name: 'Share',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
